export default function (state) {
    return  (state.system.type === 'pay' && state.system.action === 'edit')
}